module.exports = __webpack_public_path__ + "static/media/red-cross-icon.8bd5b799.svg";